export default __webpack_public_path__ + "static/py-dabae765bee139c03d8ea47043a786a0.svg";